import { render } from "./SysDefineVersionView.vue?vue&type=template&id=47aa2d1a&scoped=true"
import script from "./SysDefineVersionView.vue?vue&type=script&lang=js"
export * from "./SysDefineVersionView.vue?vue&type=script&lang=js"

import "./SysDefineVersionView.vue?vue&type=style&index=0&id=47aa2d1a&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47aa2d1a"]])

export default __exports__